import React from 'react';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import useQuery from '../../../../modules/react/hooks/useQuery';
import { compose } from '../../../../src/web/utils/react';
import { facilityWidget } from '../../../../src/web/components/widgets/decorators';
import {
  request,
  hideModal as hideCouponModal,
  showModal as showCouponModal,
} from '../../../../src/web/store/modules/coupon';
import { NAME, ID } from './properties';
import Coupon from './Coupon';

const GET_FACILITY = gql`
  query GetFacility($id: ID!) {
    facility(id: $id) {
      id
      ...CouponFacility
    }
    currentSite {
      id
      ...CouponSite
    }
  }

  ${Coupon.fragments.facility}
  ${Coupon.fragments.site}
`;

const CouponContainer = ({ facilityId, ...rest }) => {
  const { data, loading, error } = useQuery(GET_FACILITY, {
    variables: { id: facilityId },
  });

  if (loading || error) {
    return null;
  }

  const facility = data?.facility || {};
  const site = data?.currentSite || {};

  return (
    <Coupon
      {...rest}
      facilityId={facilityId}
      facility={facility}
      site={site}
    />
  );
};

export default compose(
  facilityWidget(
    { name: NAME, category: 'Promotions', componentId: ID },
    {
      defaults: {
        color: '',
        style: 'special-offer',
        text: '<div>Packing tape trailer hitch rent truck certified dealer. Large aisle ground floor park here.</div>', // eslint-disable-line max-len
        title: '<div class="bold">50% Off</div>',
      },
    },
  ),
  connect(
    (state) => {
      const { coupon } = state;
      return {
        isRequesting: coupon.requesting,
        requested: coupon.requested,
        errorMessage: coupon.errorMessage,
        show: coupon.show,
      };
    },
    {
      handleRequest: request,
      hideModal: hideCouponModal,
      showModal: showCouponModal,
    },
  ),
)(CouponContainer);
